import React from 'react';
import styled from 'styled-components';
import { string, number, object } from 'prop-types';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { clearNpvrRecordingsErrors } from 'store/actions';

// import styles
import { antModal } from 'components/styles';
import { Wrapper, Item, Info, DeleteButton, TrashIconStyled } from '../style';

// import components
import DeleteNpvrRecording from './DeleteNpvrRecording';
import LinkWrapper from '../LinkWrapper';

// import helpers and utilities
import { convertDuration } from 'helpers/time';
import useToggle from 'components/utilities/hooks/toggle/useToggle';

// Import assets
import SliderItemPlaceholder from 'assets/images/slider_item_placeholder_landscape.png';

const ModalStyled = styled(Modal)`
	${antModal()}
`;

const ItemDetailsNpvr = ({
	channelTitle,
	duration,
	recordingName,
	recordingId,
	backgroundImage,
	date,
	time,
	status,
	url
}) => {
	const { t } = useTranslation();
	const [isOpened, toggle] = useToggle(false);
	const dispatch = useDispatch();
	const recordingLength = convertDuration(duration);
	const pendingInfo = `${channelTitle} | ${date} | ${time}`;
	const readyInfo = `${channelTitle} ${
		recordingLength ? `| ${recordingLength}` : ''
	}`;

	const handleCloseModal = () => {
		// Dispatch a clearErrorRecordings action in recordings folder
		clearNpvrRecordingsErrors()(dispatch);
		// Close modal
		toggle();
	};

	const backgroundImageUrl = backgroundImage || SliderItemPlaceholder;

	return (
		<>
			<LinkWrapper status={status} url={url}>
				<Wrapper backgroundImageUrl={backgroundImageUrl} className="hover-wrap">
					<Item className="hover-item">
						{status === 'ready' && <Info title={readyInfo}>{readyInfo}</Info>}
						{status === 'pending' && (
							<Info title={pendingInfo}>{pendingInfo}</Info>
						)}
						<Info title={recordingName}>{recordingName}</Info>
					</Item>
				</Wrapper>
			</LinkWrapper>
			<DeleteButton onClick={toggle}>
				<TrashIconStyled />
			</DeleteButton>
			<ModalStyled
				maskClosable={false}
				width={500}
				closable={true}
				onCancel={handleCloseModal}
				title={t('recordings_npvr_confirm_delete_recording')}
				visible={isOpened}
				bodyStyle={{ padding: '2rem' }}
			>
				<DeleteNpvrRecording
					recordingId={recordingId}
					closeModal={handleCloseModal}
				/>
			</ModalStyled>
		</>
	);
};

ItemDetailsNpvr.propTypes = {
	channelTitle: string,
	duration: number,
	recordingName: string,
	recordingId: number,
	backgroundImage: string,
	date: string,
	time: string,
	status: string,
	url: object
};

export default ItemDetailsNpvr;
